/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Meta_DescriptionInputs */

const en_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest blog posts, press, and announcements from Mark Egly Golf in Des Moines, Iowa.`)
};

const es_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas entradas del blog, prensa y anuncios de Mark Egly Golf en Des Moines, Iowa.`)
};

const de_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Blogbeiträge, Pressemitteilungen und Ankündigungen von Mark Egly Golf in Des Moines, Iowa.`)
};

const zh_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州得梅因市 Mark Egly Golf 的最新博客文章、新闻和公告。`)
};

const ar_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث تدوينات المدونة والصحافة والأخبار من Mark Egly Golf في Des Moines, Iowa.`)
};

const fr_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniers articles de blog, presse et annonces de Mark Egly Golf à Des Moines, Iowa.`)
};

const vi_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài blog, báo chí, và thông báo mới nhất từ Mark Egly Golf tại Des Moines, Iowa.`)
};

const sw_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machapisho ya hivi karibuni ya blogu, vyombo vya habari, na matangazo kutoka kwa Mark Egly Golf huko Des Moines, Iowa.`)
};

const th_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อกโพสต์ สื่อ และประกาศล่าสุดจาก Mark Egly Golf ในเมืองดิมอยน์ รัฐไอโอวา`)
};

const bs_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnoviji blog postovi, mediji i najave od Mark Egly Golf u Des Moinesu, Iowa.`)
};

const ja_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines、IowaのMark Egly Golfの最新のブログ投稿、プレス、および発表。`)
};

const ko_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa의 Mark Egly Golf에서 최신 블로그 게시물, 보도 및 발표.`)
};

const pt_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas postagens, imprensa e anúncios do Mark Egly Golf em Des Moines, Iowa.`)
};

const it_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi post sul blog, stampa e annunci da Mark Egly Golf in Des Moines, Iowa.`)
};

const sv_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste blogginlägg, tryck och meddelanden från Mark Egly Golf i Des Moines, Iowa.`)
};

const nl_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste blog berichten, pers, en aankondigingen van Mark Egly Golf in Des Moines, Iowa.`)
};

const da_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste blog indlæg, presse, og meddelelser fra Mark Egly Golf i Des Moines, Iowa.`)
};

const nb_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste blogginnlegg, trykk og kunngjøringer fra Mark Egly Golf i Des Moines, Iowa.`)
};

const fi_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golfin uusimmat blogikirjoitukset, lehdistöjutut ja tiedotteet Des Moinesista, Iowasta.`)
};

const pl_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze posty na blogach, prasa i ogłoszenia z Mark Egly Golf w Des Moines, Iowa.`)
};

const ru_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние сообщения в блоге, пресса и объявления от Mark Egly Golf в Des Moines, Iowa.`)
};

const tr_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son blog yazıları, basın ve Mark Egly Golf'ten Des Moines'te duyurular, Iowa.`)
};

const hi_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में Mark Egly Golf से नवीनतम ब्लॉग पोस्ट, प्रेस और घोषणाएं।`)
};

const id_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postingan blog terbaru, pers, dan pengumuman dari Mark Egly Golf di Des Moines, Iowa.`)
};

const ms_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantaran blog, berita akhbar dan pengumuman terkini daripada Mark Egly Golf di Des Moines, Iowa.`)
};

const cs_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední blog příspěvky, stiskněte, a oznámení od Mark Egly Golf v Des Moines, Iowa.`)
};

const el_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τελευταίες δημοσιεύσεις blog, Τύπος, και ανακοινώσεις από Mark Egly Golf σε Des Moines, Iowa.`)
};

const he_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפוסטים האחרונים, העיתונות וההודעות של Mark Egly Golf ב Des Moines, Iowa.`)
};

const af_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die nuutste blogplasings, persberigte en aankondigings van Mark Egly Golf in Des Moines, Iowa.`)
};

const hu_blog_meta_description = /** @type {(inputs: Blog_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb blog hozzászólások, sajtó, és bejelentések Mark Egly Golf Des Moines, Iowa.`)
};

/**
* | output |
* | --- |
* | "Latest blog posts, press, and announcements from Mark Egly Golf in Des Moines, Iowa." |
*
* @param {Blog_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_meta_description = /** @type {((inputs?: Blog_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_meta_description(inputs)
	if (locale === "de") return de_blog_meta_description(inputs)
	if (locale === "zh") return zh_blog_meta_description(inputs)
	if (locale === "ar") return ar_blog_meta_description(inputs)
	if (locale === "fr") return fr_blog_meta_description(inputs)
	if (locale === "vi") return vi_blog_meta_description(inputs)
	if (locale === "sw") return sw_blog_meta_description(inputs)
	if (locale === "th") return th_blog_meta_description(inputs)
	if (locale === "bs") return bs_blog_meta_description(inputs)
	if (locale === "ja") return ja_blog_meta_description(inputs)
	if (locale === "ko") return ko_blog_meta_description(inputs)
	if (locale === "pt") return pt_blog_meta_description(inputs)
	if (locale === "it") return it_blog_meta_description(inputs)
	if (locale === "sv") return sv_blog_meta_description(inputs)
	if (locale === "nl") return nl_blog_meta_description(inputs)
	if (locale === "da") return da_blog_meta_description(inputs)
	if (locale === "nb") return nb_blog_meta_description(inputs)
	if (locale === "fi") return fi_blog_meta_description(inputs)
	if (locale === "pl") return pl_blog_meta_description(inputs)
	if (locale === "ru") return ru_blog_meta_description(inputs)
	if (locale === "tr") return tr_blog_meta_description(inputs)
	if (locale === "hi") return hi_blog_meta_description(inputs)
	if (locale === "id") return id_blog_meta_description(inputs)
	if (locale === "ms") return ms_blog_meta_description(inputs)
	if (locale === "cs") return cs_blog_meta_description(inputs)
	if (locale === "el") return el_blog_meta_description(inputs)
	if (locale === "he") return he_blog_meta_description(inputs)
	if (locale === "af") return af_blog_meta_description(inputs)
	if (locale === "hu") return hu_blog_meta_description(inputs)
	return en_blog_meta_description(inputs)
});